import React from "react";
import { Form, InputGroup, Button, Dropdown, Badge } from "react-bootstrap";
import { IoSearch, IoFilter, IoClose } from "react-icons/io5";

const SearchAndFilter = ({
  searchTerm = "",
  selectedCategory = "ALL",
  selectedPaymentStatus = "ALL",
  selectedXenditStatus = "ALL",
  onSearchChange = () => {},
  onSearchSubmit = () => {},
  onCategoryChange = () => {},
  onPaymentStatusChange = () => {},
  onXenditStatusChange = () => {},
  onClearFilters = () => {},
}) => {
  // Opsi untuk kategori
  const categoryOptions = [
    { value: "ALL", label: "All Categories" },
    { value: "SERVICE", label: "SERVICE" },
    { value: "APPOINTMENT", label: "APPOINTMENT" },
    { value: "PRODUCT", label: "PRODUCT" },
  ];

  // Opsi untuk status payment
  const paymentStatusOptions = [
    { value: "ALL", label: "All Payment Status" },
    { value: "PAYMENT SUCCESS", label: "Payment Success" },
    { value: "NEED PAYMENT", label: "Need Payment" },
    { value: "PAYMENT FAILED", label: "Payment Failed" },
  ];

  // Opsi untuk status xendit
  const xenditStatusOptions = [
    { value: "ALL", label: "All Xendit Status" },
    { value: "PAID", label: "Paid" },
    { value: "PENDING", label: "Pending" },
  ];

  // Cek apakah ada filter aktif
  const isFilterActive =
    selectedCategory !== "ALL" ||
    selectedPaymentStatus !== "ALL" ||
    selectedXenditStatus !== "ALL";

  return (
    <div className="row g-3 mb-4">
      {/* Search Input */}
      <div className="col-md-4">
        <Form onSubmit={onSearchSubmit}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search by order ID..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <Button variant="primary" type="submit">
              <IoSearch /> Search
            </Button>
          </InputGroup>
        </Form>
      </div>

      {/* Category Filter */}
      <div className="col-md-2">
        <Dropdown>
          <Dropdown.Toggle
            variant={selectedCategory !== "ALL" ? "primary" : "outline-secondary"}
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {categoryOptions.find((opt) => opt.value === selectedCategory)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {categoryOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedCategory === option.value}
                onClick={() => onCategoryChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Payment Status Filter */}
      <div className="col-md-2">
        <Dropdown>
          <Dropdown.Toggle
            variant={selectedPaymentStatus !== "ALL" ? "primary" : "outline-secondary"}
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {paymentStatusOptions.find((opt) => opt.value === selectedPaymentStatus)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {paymentStatusOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedPaymentStatus === option.value}
                onClick={() => onPaymentStatusChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Xendit Status Filter */}
      <div className="col-md-2">
        <Dropdown>
          <Dropdown.Toggle
            variant={selectedXenditStatus !== "ALL" ? "primary" : "outline-secondary"}
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {xenditStatusOptions.find((opt) => opt.value === selectedXenditStatus)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {xenditStatusOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedXenditStatus === option.value}
                onClick={() => onXenditStatusChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Active Filters Badge */}
      {isFilterActive && (
        <div className="col-12">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <small className="text-muted">Active filters:</small>
            {selectedCategory !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Category:{" "}
                {categoryOptions.find((opt) => opt.value === selectedCategory)?.label}
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onCategoryChange("ALL")}
                />
              </Badge>
            )}
            {selectedPaymentStatus !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Payment:{" "}
                {paymentStatusOptions.find((opt) => opt.value === selectedPaymentStatus)?.label}
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onPaymentStatusChange("ALL")}
                />
              </Badge>
            )}
            {selectedXenditStatus !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Xendit:{" "}
                {xenditStatusOptions.find((opt) => opt.value === selectedXenditStatus)?.label}
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onXenditStatusChange("ALL")}
                />
              </Badge>
            )}
            <Button
              variant="link"
              size="sm"
              className="p-0 text-decoration-none"
              onClick={onClearFilters}
            >
              Clear all
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchAndFilter;